import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

class QuoteExportedToQuickBooksEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        let url = 'https://sandbox.qbo.intuit.com/app/invoice?txnId='
        if (AppContext.getOptions().environment === "prod") {
            url = 'https://qbo.intuit.com/app/invoice?txnId='
        }
        url = url + this.state.object.attributes.externalId
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    <FormattedMessage
                        id="quote.analytics.events.exported.quick_books.text"
                        defaultMessage="Proposal {identifier} has been exported to QuickBooks as an invoice"
                        values={{
                            identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={url} target="_blank">
                        <img src="/images/quickbooks_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={url} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="quote.analytics.events.exported.quick_books.open"
                                defaultMessage="Open invoice in QuickBooks"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default QuoteExportedToQuickBooksEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-quick-books.component.jsx